import { extendTheme } from '@chakra-ui/react';
import Card from './card';
import Modal from './modal';
import Button from './boton';
import Input from './input';
import colores from './colores';
import Popover from './popover';
import Badge from './badge';
import Checkbox from './checkbox';

const tema = extendTheme({
  fonts: {
    heading: `'Ubuntu', sans-serif`,
    body: `'Open Sans', sans-serif`,
    p: `'Source Sans 3', sans-serif`,
  },
  styles: {
    global: {
      body: { bg: 'background', color: 'foreground' },
      p: { fontFamily: 'p' }, // Asigna la tipografía a las etiquetas p globalmente
    },
  },
  components: {
    Button,
    Input,
    PopoverContent: Popover,
    Badge,
    Modal,
    Card,
    Checkbox,
  },
  colors: colores,
});

export default tema;
